import { PortfolioEnergyChart } from "../PortfolioEnergyChart"
import { DisplayMode } from "../../../../hooks/useGetBuildingsEnergy";
import { useStyletron } from "baseui";
import { OverviewPanelWrapper } from "../../../components/OverviewPanelWrapper";
import { FormattedMessage } from "react-intl";
import { startEndDateFromTimeRange } from "../PortfolioEnergyChart/utils";
import { TimeRange } from "../PortfolioEnergyChart/types";
import { MdCo2 } from 'react-icons/md'

const EmissionsChart = (props: any) => {
    const [css, theme] = useStyletron();
    const { start, end } = startEndDateFromTimeRange(props.timeRange);

    const convertToTons = !props.byM2;
    const displayUnitString = convertToTons ? "t" : 'kg';
    const valueFactor = convertToTons ? 0.001 : 1;

    return (
        <OverviewPanelWrapper {...props} icon={<MdCo2  size='100%' color={theme.colors.backgroundPrimary}></MdCo2>}
        description={<FormattedMessage id="TopEmmissionsChart.Emmissions" defaultMessage="Emissions" />}
         name={<Name {...props} start={start} end={end}></Name>}>
            <PortfolioEnergyChart valueFactor={valueFactor} dimension={displayUnitString} colors={[theme.colors.positive200]} color={theme.colors.primary}  byM2={props.byM2} start={start} end={end} take={props.numItems} displayMode={DisplayMode.CO2} ></PortfolioEnergyChart>
        </OverviewPanelWrapper>
    )
}

export default EmissionsChart;


const Name = (props: any) => {

    const convertToTons = !props.byM2;
    const displayUnitString = convertToTons ? "t" : 'kg';

    return (
        <>
            <> Top {props.numItems} | <FormattedMessage id={TimeRange[props.timeRange]} defaultMessage={TimeRange[props.timeRange]} /> | {displayUnitString} CO2
            </>
            {props.byM2 && '/m²'}
        </>
    )
}